import formatNumber from './format-number';
import formatDate from './format-date';

export default {
    formatNumber,
    formatDate,
};
